"use strict";

module.exports = function () {
  return {
    Heading: {
      type: "block",
      data: {
        pStyle: "Heading",
        props: []
      }
    },
    Heading1: {
      type: "block",
      data: {
        pStyle: "Heading1",
        props: []
      }
    },
    Heading2: {
      type: "block",
      data: {
        pStyle: "Heading2",
        props: []
      }
    },
    Heading3: {
      type: "block",
      data: {
        pStyle: "Heading3",
        props: []
      }
    },
    Heading4: {
      type: "block",
      data: {
        pStyle: "Heading4",
        props: []
      }
    },
    Heading5: {
      type: "block",
      data: {
        pStyle: "Heading5",
        props: []
      }
    },
    Code: {
      type: "block",
      data: {
        pStyle: "Code",
        props: []
      }
    }
  };
};